import { EMPTY, formatCuit, formatDate, formatRelativeDays, formatTime, toIsoDate, todayIso } from "../crmpostventa-shared/crmFormat";

// Display rules of the Ficha (design Prompts 0 and 1): "—" for what is missing, never another field's value; Argentine
// formats for CUIT, dates and decimals. Pure helpers, no data of their own.

export const TIPOS_CAMPO = {
  EDITABLE: "EDITABLE",
  SOLO_LECTURA: "SOLO_LECTURA",
  TRAMITE: "TRAMITE",
};

export const ORIGEN_LABELS = {
  FICHA: "Ficha",
  GESTION_IPC: "Gestión IPC",
  CRM_ANTERIOR: "CRM anterior",
};

// Last changes shown in the Ficha (the server sends at most this many).
export const ULTIMOS_CAMBIOS = 5;

const CUIT_KEYS = new Set(["cuitCuil", "cuitRazonSocial"]);

const isEmpty = (value) => value === null || value === undefined || String(value).trim() === "";

export const isLocked = (campo) => campo?.tipo === TIPOS_CAMPO.SOLO_LECTURA || campo?.tipo === TIPOS_CAMPO.TRAMITE;

export const isTramite = (campo) => campo?.tipo === TIPOS_CAMPO.TRAMITE;

// Value of a field as the card shows it: FECHA values come as yyyy-MM-dd, DECIMAL with a dot.
export const formatCampoValor = (campo) => {
  const valor = campo?.valor;
  if (isEmpty(valor)) return EMPTY;
  if (CUIT_KEYS.has(campo.clave)) return formatCuit(valor);
  if (campo.formato === "FECHA") return formatDate(valor);
  if (campo.formato === "DECIMAL") return String(valor).replace(".", ",");
  return String(valor);
};

// A history value ("—" when empty).
export const formatHistorialValor = (value) => (isEmpty(value) ? EMPTY : String(value));

export const origenLabel = (origen) => ORIGEN_LABELS[origen] || origen || EMPTY;

export const isLegacy = (item) => item?.origen === "CRM_ANTERIOR";

// "dd/mm/aaaa hh:mm" of a server date-time ("dd/mm/aaaa" when it has no time).
export const formatFechaHora = (value) => {
  const time = formatTime(value);
  const date = formatDate(value);
  return time && date !== EMPTY ? `${date} ${time}` : date;
};

// Whole calendar days from a server date to today ("hace 3 días"), or null without a date.
export const formatHace = (value, today = todayIso()) => {
  const from = toIsoDate(value);
  if (!from || !today) return null;
  const toUtc = (iso) => Date.UTC(Number(iso.slice(0, 4)), Number(iso.slice(5, 7)) - 1, Number(iso.slice(8, 10)));
  return formatRelativeDays(Math.round((toUtc(today) - toUtc(from)) / 86400000));
};

// Chip tone of the terminal state (Rollo status tokens).
export const estadoTone = (estado) => {
  const code = String(estado ?? "").trim().toUpperCase();
  if (code === "ALTA" || code === "ACTIVA" || code === "ACTIVO") return "delivered";
  if (code === "BAJA") return "cancelled";
  return "requested";
};
